// menuData.ts
import {
  IconDashboard,
  IconDevices,
  IconLogs,
  IconShieldLock,
  IconUsers,
  IconUsersGroup,
} from "@tabler/icons-react";
import { MenuItem } from "../types/types";
const isDev = process.env.REACT_APP_IS_DEV === "true";

export const MenuOptions: { label: string; value: string }[] = [
  { label: "전체", value: "" },
  { value: "/DashBoard", label: "대시보드" },
  { value: "/Terminals", label: "단말기 관리" },
  { value: "/SCSproSnInject", label: "키 주입" },
  { value: "/TerminalModels", label: "단말기 모델" },
  { value: "/TerminalAddHistory", label: "등록 이력" },
  { value: "/ActionLog", label: "로그 관리" },
  { value: "/Users", label: "유저 관리" },
  { value: "/Permissions", label: "권한 관리" },
  { value: "/WorkerApproval", label: "작업자 승인" },
  { value: "/Workers", label: "작업자 관리" },
];

export const MENU_MAP: Record<string, string> = {
  "/DashBoard": "대시보드",
  "/Terminals": "단말기 관리",
  "/SCSproSnInject": "키 주입",
  "/TerminalModels": "단말기 모델",
  "/TerminalAddHistory": "등록 이력",
  "/ActionLog": "로그 관리",
  "/Users": "유저 관리",
  "/Permissions": "권한 관리",
  "/WorkerApproval": "작업자 승인",
  "/Workers": "작업자 관리",
};

export const MENU_DATA: MenuItem[] = [
  { name: "대시보드", apiUrl: "/DashBoard", icon: IconDashboard },
  {
    name: "단말기",
    icon: IconDevices,
    open: true,
    sub: [
      { name: "단말기 관리", apiUrl: "/Terminals" },
      { name: "키 주입", apiUrl: "/SCSproSnInject" },
      { name: "단말기 모델", apiUrl: "/TerminalModels" },
      { name: "등록 이력", apiUrl: "/TerminalAddHistory" },
    ],
  },
  { name: "로그관리", apiUrl: "/ActionLog", icon: IconLogs },
  { name: "유저관리", apiUrl: "/Users", icon: IconUsers },
  { name: "권한관리", apiUrl: "/Permissions", icon: IconShieldLock },
  {
    name: "작업자관리",
    icon: IconUsersGroup,
    open: true,
    sub: [
      { name: "작업자 관리", apiUrl: "/Workers" },
      { name: "작업자 승인", apiUrl: "/WorkerApproval" },
    ],
  },
];

export const TEMP_ROLE_DATA = (): {
  apiUrl: string;
  isRead: string;
  isWrite: string;
}[] => {
  if (isDev) {
    return [
      { apiUrl: "/DashBoard", isRead: "Y", isWrite: "Y" },
      { apiUrl: "/Terminals", isRead: "Y", isWrite: "Y" },
      { apiUrl: "/SCSproSnInject", isRead: "Y", isWrite: "Y" },
      { apiUrl: "/TerminalModels", isRead: "Y", isWrite: "Y" },
      { apiUrl: "/TerminalAddHistory", isRead: "Y", isWrite: "Y" },
      { apiUrl: "/ActionLog", isRead: "Y", isWrite: "Y" },
      { apiUrl: "/Users", isRead: "Y", isWrite: "Y" },
      { apiUrl: "/Permissions", isRead: "Y", isWrite: "Y" },
      { apiUrl: "/WorkerApproval", isRead: "Y", isWrite: "Y" },
      { apiUrl: "/Workers", isRead: "Y", isWrite: "Y" },
    ];
  } else {
    return [];
  }
};
